/**
 * Dashboard Repository Implementation
 * Implementa as regras de acesso aos dados do dashboard
 */
import { DashboardRepository } from '../../domain/repositories/dashboard_repository';
import { DashboardStatsEntity, DashboardMetricsEntity } from '../../domain/entities/dashboard_entity';
import { DashboardRemoteDataSource } from '../datasources/remote/dashboard_remote_datasource';

export class DashboardRepositoryImpl implements DashboardRepository {
  constructor(private remoteDataSource: DashboardRemoteDataSource) {}

  async getStats(): Promise<DashboardStatsEntity> {
    console.log('📊 Repository: Obtendo estatísticas do dashboard...');
    
    try {
      const response = await this.remoteDataSource.fetchStats();
      
      // Mapear os dados da API para a entidade de domínio
      const stats: DashboardStatsEntity = {
        totalCustomers: response.total_customers || 0,
        totalRevenue: response.total_revenue || 0,
        monthlyGrowth: response.monthly_growth || 0,
        activeServices: response.active_services || 0,
        pendingOrders: response.pending_orders || 0,
        completedOrders: response.completed_orders || 0,
        lastUpdated: response.last_updated ? new Date(response.last_updated) : new Date()
      };
      
      console.log('✅ Repository: Estatísticas processadas', stats);
      return stats;
    } catch (error) {
      console.error('❌ Repository: Erro ao obter estatísticas', error);
      throw new Error(`Erro ao obter estatísticas do dashboard: ${error}`);
    }
  }

  async getMetrics(period?: 'day' | 'week' | 'month' | 'year'): Promise<DashboardMetricsEntity> {
    console.log('📈 Repository: Obtendo métricas do dashboard...', { period });
    
    try {
      const response = await this.remoteDataSource.fetchMetrics(period);
      
      // Mapear os dados da API para a entidade de domínio
      const metrics: DashboardMetricsEntity = {
        dailyRevenue: response.daily_revenue || [],
        customerGrowth: response.customer_growth || [],
        serviceUsage: response.service_usage || {},
        popularServices: response.popular_services || [],
        revenueByService: response.revenue_by_service || {}
      };
      
      console.log('✅ Repository: Métricas processadas');
      return metrics;
    } catch (error) {
      console.error('❌ Repository: Erro ao obter métricas', error);
      throw new Error(`Erro ao obter métricas do dashboard: ${error}`);
    }
  }

  async refreshStats(): Promise<void> {
    console.log('🔄 Repository: Atualizando cache das estatísticas...');
    
    try {
      // Invalidar cache e buscar dados atualizados
      await this.remoteDataSource.fetchStats();
      console.log('✅ Repository: Cache atualizado');
    } catch (error) {
      console.error('❌ Repository: Erro ao atualizar cache', error);
      throw new Error(`Erro ao atualizar cache das estatísticas: ${error}`);
    }
  }

  async getStatsByPeriod(startDate: Date, endDate: Date): Promise<DashboardStatsEntity> {
    console.log('📅 Repository: Obtendo estatísticas por período...', { startDate, endDate });
    
    try {
      // Converter Date para string no formato ISO
      const startDateStr = startDate.toISOString().split('T')[0];
      const endDateStr = endDate.toISOString().split('T')[0];
      
      const response = await this.remoteDataSource.fetchStatsByPeriod(startDateStr, endDateStr);
      
      // Mapear os dados da API para a entidade de domínio
      const stats: DashboardStatsEntity = {
        totalCustomers: response.total_customers || 0,
        totalRevenue: response.total_revenue || 0,
        monthlyGrowth: response.monthly_growth || 0,
        activeServices: response.active_services || 0,
        pendingOrders: response.pending_orders || 0,
        completedOrders: response.completed_orders || 0,
        lastUpdated: response.last_updated ? new Date(response.last_updated) : new Date()
      };
      
      console.log('✅ Repository: Estatísticas por período processadas', stats);
      return stats;
    } catch (error) {
      console.error('❌ Repository: Erro ao obter estatísticas por período', error);
      throw new Error(`Erro ao obter estatísticas por período: ${error}`);
    }
  }
}
